import React from 'react';
export var ICON_TYPES = [
    'aboveboard',
    'add',
    'addressAs',
    'alert',
    'alertTriangle',
    'arrowDown',
    'arrowLeft',
    'arrowRight',
    'arrowUp',
    'bolt',
    'briefcase',
    'businessDealHandshake',
    'calendar',
    'calendarCheck',
    'calendarClock',
    'cancel',
    'check',
    'chevronDown',
    'chevronLeft',
    'chevronRight',
    'chevronUp',
    'clear',
    'close',
    'connections',
    'connectionsOpen',
    'copy',
    'dashArrow',
    'delete',
    'download',
    'dropdown',
    'edit',
    'editSpreadsheet',
    'export',
    'filter',
    'flash',
    'funnel',
    'house',
    'imageListView',
    'itemNote',
    'jobSearchProfile',
    'linkedIn',
    'mail',
    'mailchimp',
    'magicWand',
    'mapMarker',
    'messagesBubble',
    'moveRight',
    'multipleNeutral',
    'navigationMenu',
    'newNote',
    'note',
    'notesChecklistFlip',
    'notesTextFlip',
    'notification',
    'options',
    'person',
    'print',
    'ratingStar',
    'refresh',
    'relations',
    'roadSignBanned',
    'treeStructure',
    'schedule',
    'search',
    'share',
    'shoppingCart',
    'singleNeutralActionsAdd',
    'singleNeutralActionsChat',
    'singleNeutralActionsDownload',
    'singleNeutralActionsMail',
    'singleNeutralActionsMobile',
    'singleNeutralActionsRemove',
    'singleNeutralActionsShare',
    'singleNeutralActionsUpload',
    'spreadsheet',
    'stopwatch',
    'subtract',
    'task',
    'taskListPin',
    'upload',
    'view',
];
// #endregion Available Icon Types & Helper Array
var iconTypes = {
    aboveboard: {
        title: 'AboveBoard',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M12.4 14H1.6C.7 14 0 13.3 0 12.4V1.6C0 .7.7 0 1.6 0h10.9c.8 0 1.5.7 1.5 1.6v10.9c0 .8-.7 1.5-1.6 1.5z', fill: '#2A8CB8', fillRule: 'nonzero' }),
            React.createElement("path", { d: 'M5.5916 4.0398a.1498.1498 0 00-.1328-.0784.1507.1507 0 00-.133.0788L3.4203 7.397a.1632.1632 0 00-.001.161c.0135.0242.0533.0807.134.0807h4.0922l-2.054-3.599zM3.5533 8.1513c-.2354 0-.4458-.1268-.5627-.339a.6875.6875 0 01.0042-.6755L4.9003 3.78c.1175-.2073.326-.3312.5577-.3314h.0008c.2312 0 .4397.1232.5577.3299l2.203 3.8602h1.1312c.0807 0 .1205-.0567.134-.0809a.1628.1628 0 00-.0014-.1612L5.5954.5912a.1534.1534 0 00-.1338-.0786.1511.1511 0 00-.133.0803L.5154 9.2468a.1633.1633 0 000 .1603c.0137.0242.0535.0801.1338.0801l7.7782-.0035c.0811 0 .121-.0566.1342-.081a.1624.1624 0 00-.0014-.161L7.938 8.1514H3.5533zM.088 9.6634a.6878.6878 0 010-.673L4.901.3365c.1167-.2092.325-.335.5579-.3364h.0038c.2312 0 .4394.123.5575.3297l3.888 6.8054a.6876.6876 0 01.0059.6763c-.1167.213-.3275.34-.5633.34H8.512l.4733.829a.6877.6877 0 01.0054.6761c-.1167.2127-.327.3397-.5631.34L.6494 10H.6492c-.2344 0-.444-.1257-.5613-.3366z', mask: 'url(#b)' })))
    },
    add: {
        title: 'Add',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M2.0938 16.0938h28' }),
            React.createElement("path", { d: 'M16.0938 2.0938v28' })))
    },
    addressAs: {
        title: 'Address As',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M26.24136 11.99355c2.13895-3.3524 2.13895-7.64116 0-10.99355M21.7495 9.96671c1.61425-1.98701 1.61425-4.83363 0-6.82065' }),
            React.createElement("g", { transform: 'translate(4.16129 1.7742)' },
                React.createElement("circle", { cx: '8.12903', cy: '4.64516', r: '4.64516' }),
                React.createElement("path", { d: 'M12.19355 29.03226l.58064-5.80645h3.48387v-3.48387c0-4.48955-3.63949-8.12904-8.12903-8.12904S0 15.2524 0 19.74194v3.48387h3.48387l.58065 5.80645' }))))
    },
    alert: {
        title: 'Alert',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M16.115 26.721a.837.837 0 100 1.673.837.837 0 000-1.673h0' }),
            React.createElement("path", { d: 'M16.115 21.404V3' })))
    },
    alertTriangle: {
        title: 'Alert Triangle',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M16 26a.5.5 0 0 1 0-1m0 1a.5.5 0 0 0 0-1' }),
            React.createElement("path", { d: 'M16 21V11' }),
            React.createElement("path", { d: 'M18.1613 2.3467a2.4079 2.4079 0 0 0-4.3226 0L1.208 28.0773A2.0282 2.0282 0 0 0 3.0293 31h25.9414a2.0275 2.0275 0 0 0 1.7225-.9555 2.0279 2.0279 0 0 0 .0988-1.9672L18.1613 2.3467Z' })))
    },
    arrowDown: {
        title: 'Arrow Down',
        content: (React.createElement("path", { d: 'M16.182 3.295v26.591M3.773 17.477l12.409 12.41 12.409-12.41' }))
    },
    arrowLeft: {
        title: 'Arrow Left',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M29.1818 16.4773H2.591' }),
            React.createElement("path", { d: 'M15 4.0682L2.591 16.4772 15 28.8865' })))
    },
    arrowRight: {
        title: 'Arrow Right',
        content: (React.createElement("path", { d: 'M2.591 15.887h26.591M16.773 28.295l12.409-12.409-12.41-12.409' }))
    },
    arrowUp: {
        title: 'Arrow Up',
        content: React.createElement("path", { d: 'M16 29.478V2.887M28.41 15.295L16 2.886 3.59 15.296' })
    },
    bolt: {
        title: 'Bolt',
        content: (React.createElement("path", { d: 'M23.7973 15.0747a1.364 1.364 0 0 0-1.1613-2.0787H18v-12L8.2027 16.9187A1.3627 1.3627 0 0 0 9.364 18.996H14v12Z' }))
    },
    briefcase: {
        title: 'Briefcase',
        content: (React.createElement("path", { d: 'M31.33 28A1.33 1.33 0 0 1 30 29.33H2A1.33 1.33 0 0 1 .67 28V9.33A1.33 1.33 0 0 1 2 8h28a1.33 1.33 0 0 1 1.33 1.33V28ZM10.67 8l.66-4.67a.67.67 0 0 1 .67-.66h8a.67.67 0 0 1 .67.66L21.33 8M6 13.34h20M6 18.67h20M6 24h20' }))
    },
    businessDealHandshake: {
        title: 'Business Deal Handshake',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { className: 'Icon--useThinStroke', d: 'M18.4 21h4.9l3-.6a1.3 1.3 0 0 0 1-1.3V12a1.3 1.3 0 0 0-.8-1.3L19.8 8a2 2 0 0 0-2 .3l-5 4a1 1 0 0 0 1 1.8l5.5-1.8' }),
            React.createElement("path", { className: 'Icon--useThinStroke', d: 'M4.7 18.3 8 19l4.8 4.7a1.3 1.3 0 0 0 1.2.4l.6-.1a1.3 1.3 0 0 0 1.1-1l.3-1.4 2.2-.4.4-2.3 2.3-.4.4-2.3-3.5-3.4m-2.4-2.6-2-2A1.3 1.3 0 0 0 12 8L8 9.6l-3.3.7' }),
            React.createElement("path", { className: 'Icon--useThinStroke', d: 'M.7 8.3h2.6a1.3 1.3 0 0 1 1.4 1.3V19a1.3 1.3 0 0 1-1.4 1.3H.7v-12Zm28 1.3h2.6v12h-2.6a1.3 1.3 0 0 1-1.4-1.3V11a1.3 1.3 0 0 1 1.4-1.4Z' })))
    },
    calendar: {
        title: 'Calendar',
        content: (React.createElement("path", { d: 'M30 3.33H2c-.74 0-1.33.6-1.33 1.34V30c0 .74.6 1.33 1.33 1.33h28c.74 0 1.33-.6 1.33-1.33V4.67c0-.74-.6-1.34-1.33-1.34ZM7.33.67v6.66M24.67.67v6.66M.67 10h30.66' }))
    },
    calendarCheck: {
        title: 'Calendar Check',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M15.3 23.3a8 8 0 1 0 16 0 8 8 0 0 0-16 0Z' }),
            React.createElement("path", { d: 'M26.9 21 23 26.2a1 1 0 0 1-1.5 0l-2-2m-6.8.5H2a1.3 1.3 0 0 1-1.3-1.4V4.7A1.3 1.3 0 0 1 2 3.3h24a1.3 1.3 0 0 1 1.3 1.4v8.6M7.3.7v6.6M20.7.7v6.6M.7 10h26.6' })))
    },
    calendarClock: {
        title: 'Calendar Clock',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M15.3 23.3a8 8 0 1 0 16 0 8 8 0 0 0-16 0Z' }),
            React.createElement("path", { d: 'M26 23.3h-2.7v-4m-10.6 5.4H2a1.3 1.3 0 0 1-1.3-1.4V4.7A1.3 1.3 0 0 1 2 3.3h24a1.3 1.3 0 0 1 1.3 1.4v8.6M7.3.7v6.6M20.7.7v6.6M.7 10h26.6' })))
    },
    cancel: {
        title: 'Cancel',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '15.919', cy: '15.901', r: '13.345' }),
            React.createElement("path", { d: 'M6.482 25.336L25.354 6.467' })))
    },
    check: {
        title: 'Check',
        content: (React.createElement("path", { d: 'M29.125 2.874L11.518 28.026a2.567 2.567 0 01-4.164.069l-4.479-5.971' }))
    },
    chevronDown: {
        title: 'Chevron Down',
        content: (React.createElement("path", { d: 'M29.507 9.743L17 22.25a.874.874 0 01-1.237 0L3.257 9.743' }))
    },
    chevronLeft: {
        title: 'Chevron Left',
        content: (React.createElement("path", { d: 'M23.125 29.125L10.618 16.618a.874.874 0 010-1.236L23.125 2.875' }))
    },
    chevronRight: {
        title: 'Chevron Right',
        content: (React.createElement("path", { d: 'M9.875 2.875l12.507 12.507a.874.874 0 010 1.236L9.875 29.125' }))
    },
    chevronUp: {
        title: 'Chevron Up',
        content: (React.createElement("path", { d: 'M3.257 22.507L15.763 10A.874.874 0 0117 10l12.507 12.507' }))
    },
    clear: {
        title: 'Clear',
        content: (React.createElement("path", { d: 'M30 16c0 7.178-5.822 13-13 13-7.18 0-13-5.822-13-13C4 8.82 9.82 3 17 3c7.178 0 13 5.82 13 13zM24.429 16H9.571' }))
    },
    close: {
        title: 'Close',
        content: React.createElement("path", { d: 'M2.875 29.124l26.25-26.25M29.125 29.124L2.875 2.874' })
    },
    connections: {
        title: 'Connections',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { className: 'Icon--useFill', d: 'M28.6 16.8a11 11 0 0 0-2.5-4.5 9.2 9.2 0 0 0-4.4-2.7c0 .2 0 .3.2.5 0 .2 0 .3.2.5v.3l.1 1.6c1 .5 2 1.3 2.7 2.3.7 1 1.2 2.2 1.4 3.4V20c0 .7-.2 1.2-.4 1.9a7 7 0 0 1-1.8 3 7 7 0 0 1-3 1.9c-1.2.3-2.4.5-3.6.3a8.4 8.4 0 0 1-3.4-1.3c-1-.7-1.8-1.7-2.3-2.7-.5 0-.9 0-1.4-.2h-.3c-.2 0-.3 0-.5-.2l-.5-.1a9.6 9.6 0 0 0 2.7 4.3c1.3 1.2 2.9 2 4.5 2.6 1.7.5 3.6.3 5.3 0a10.6 10.6 0 0 0 7.2-7.3 19 19 0 0 0-.2-5.4Z' }),
            React.createElement("path", { className: 'Icon--useFill', d: 'm20.7 12-.3-.2h-.7c-1-.2-2.2-.2-3.2 0-1.2.3-2.4 1-3.4 2-.8.9-1.5 2-2 3.4A9.9 9.9 0 0 0 11 21l.2.5.4 1 .1.1c2.7 0 5.4-1 7.3-3 1.8-1.8 3-4.5 3-7.2 0 0-.2 0-.2-.2-.1-.2-.6-.3-1-.3Z' }),
            React.createElement("path", { className: 'Icon--useFill', d: 'M8.6 21c-.2-.5-.2-1-.2-1.6v-.2c0-2.7 1-5.4 3-7.2 2-1.9 4.6-3 7.3-3h1.8c.2 0 .4.3.7.3l.5.1A9.6 9.6 0 0 0 19 5.1c-1.3-1.2-2.8-2-4.5-2.6a11 11 0 0 0-5.2 0 9 9 0 0 0-4.8 2.7A10.7 10.7 0 0 0 2 9.6a9.2 9.2 0 0 0 0 5.2 11 11 0 0 0 2.5 4.6A9.2 9.2 0 0 0 8.8 22v-.5c-.2-.2-.2-.4-.2-.5Z' })))
    },
    connectionsOpen: {
        title: 'Connections Open',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '11.5', cy: '11.5', r: '9.75' }),
            React.createElement("circle", { cx: '18.5', cy: '18.5', r: '9.75' })))
    },
    copy: {
        title: 'Copy',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M10.196 8.268V4.089c0-.769.624-1.393 1.393-1.393h9.87c.37 0 .723.147.984.408l5.453 5.453c.26.26.408.615.408.984v12.655c0 .77-.624 1.393-1.393 1.393h-4.179' }),
            React.createElement("path", { d: 'M28.304 9.66h-5.572c-.77 0-1.393-.623-1.393-1.392V2.696M3.696 14.768v-4.179c0-.769.624-1.393 1.393-1.393h9.87c.37 0 .723.147.984.408l5.453 5.453c.26.26.408.615.408.984v12.655c0 .77-.624 1.393-1.393 1.393H3.696V14.768z' }),
            React.createElement("path", { d: 'M21.804 16.16h-5.572c-.77 0-1.393-.623-1.393-1.392V9.196' })))
    },
    dashArrow: {
        title: 'Dash Arrow',
        content: (React.createElement("path", { d: 'M16.001 11.5h-3V7.75L4.751 16l8.25 8.25V20.5h3M19.001 11.5h3M25.001 11.5h2.25M19.001 20.5h3M25.001 20.5h2.25' }))
    },
    "delete": {
        title: 'Delete',
        content: (React.createElement("path", { d: 'M3.591 7.136h24.818M18.66 3.59h-5.32c-.978 0-1.772.795-1.772 1.774v1.772h8.864V5.364c0-.98-.794-1.773-1.773-1.773zM13.341 22.205v-8.864M18.659 22.205v-8.864M24.113 26.783a1.773 1.773 0 01-1.767 1.626H9.655c-.922 0-1.69-.707-1.767-1.626L6.25 7.136h19.5l-1.637 19.647z' }))
    },
    download: {
        title: 'Download',
        content: (React.createElement("path", { d: 'M15.578 6v15M10.147 15.375L15.577 21l5.432-5.625M29.155 21v1.875c0 2.071-1.62 3.75-3.62 3.75H5.62c-2 0-3.621-1.679-3.621-3.75V21' }))
    },
    dropdown: {
        title: 'Dropdown',
        content: (React.createElement("path", { d: 'M29.507 9.743L17 22.25a.874.874 0 01-1.237 0L3.257 9.743' }))
    },
    edit: {
        title: 'Edit',
        content: (React.createElement("path", { d: 'M28.888 4.112a4.245 4.245 0 00-6.03.04L5.94 21.07l-2.066 8.056 8.056-2.066 16.916-16.917a4.245 4.245 0 00.041-6.03zM22.374 4.637l5.989 5.989M19.931 7.08l5.989 5.989M5.941 21.069l5.996 5.984' }))
    },
    editSpreadsheet: {
        title: 'Edit Spreadsheet',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M1 8.6667h23v1.9166-5.75C24 2.7163 22.2838 1 20.1667 1H4.8333C2.7163 1 1 2.7162 1 4.8333v15.3334C1 22.2837 2.7162 24 4.8333 24h5.75-1.9166V1h7.6666v15.3333H1' }),
            React.createElement("path", { d: 'M28.1712 17.827L18.0006 28 13 29l1.0001-4.9999 10.176-10.173a2.8179 2.8179 0 013.9884 0l.012.0106c1.1 1.1031 1.0977 2.889-.0053 3.9892z' })))
    },
    "export": {
        title: 'Export',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M11.577 15v-4.6667c0-2.0618 1.7219-3.7333 3.846-3.7333H26l-5.7692 5.6L26 6.6 20.2308 1' }),
            React.createElement("path", { d: 'M22.1538 17.8v9.3333c0 1.031-.861 1.8667-1.923 1.8667H2.923C1.861 29 1 28.1643 1 27.1333V12.2c0-1.031.861-1.8667 1.923-1.8667h2.8847' })))
    },
    filter: {
        title: 'Filter',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '12.161', cy: '6.259', r: '2.893' }),
            React.createElement("circle", { cx: '12.161', cy: '25.564', r: '2.893' }),
            React.createElement("path", { d: 'M15.056 6.259H29.52M15.056 25.564H29.52M3.484 6.259H9.27M3.484 25.564H9.27' }),
            React.createElement("circle", { cx: '20.839', cy: '15.671', r: '2.893' }),
            React.createElement("path", { d: 'M17.948 15.671H3.484M29.52 15.671h-5.786' })))
    },
    flash: {
        title: 'Flash',
        content: (React.createElement("path", { d: 'M8.394 27l4.536-10.506a.83.83 0 00-.071-.787.842.842 0 00-.7-.375H8.842a.84.84 0 01-.704-.375.827.827 0 01-.069-.789L13.208 2.5a.84.84 0 01.769-.5h8.62a.84.84 0 01.757.473c.14.289.1.632-.102.882L18.718 8.98a.828.828 0 00-.1.881.84.84 0 00.756.472h3.786a.84.84 0 01.776.515c.13.312.058.67-.183.909L8.393 27z' }))
    },
    funnel: {
        title: 'Funnel',
        content: (React.createElement("path", { d: 'M28.998 1.961c.0169-.2487-.0738-.493-.2505-.675-.1767-.182-.4236-.2855-.6824-.286H1.935c-.2588 0-.506.1035-.6828.2856-.1767.1821-.2673.4266-.25.6754.4508 6.0454 5.024 11.063 11.1894 12.2764v11.862c.0001.3495.21.6674.5386.8156s.7166.1.9954-.1237l3.7414-3.003c.2135-.171.337-.4245.3367-.692v-8.8589C23.9712 13.0262 28.5471 8.008 28.998 1.961z' }))
    },
    house: {
        title: 'House',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M0.666181818,14.7941818 L14.3898182,1.05890909 C14.8003778,0.650783322 15.3563032,0.422551221 15.9352006,0.424448985 C16.514098,0.426370525 17.0685055,0.658265365 17.4763636,1.06909091 L31.2116364,14.7941818' }),
            React.createElement("polyline", { points: '26.848 10.4334545 26.848 27.8850909 5.02981818 27.8850909 5.02981818 10.4261818' }),
            React.createElement("path", { d: 'M20.3025455,27.8850909 L20.3025455,21.3396364 C20.3025455,18.9296665 18.3488789,16.976 15.9389091,16.976 C13.5289393,16.976 11.5752727,18.9296665 11.5752727,21.3396364 L11.5752727,27.8850909' })))
    },
    imageListView: {
        title: 'Image List View',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M11.75 6.467h16.5M11.75 16.967h16.5M11.75 27.467h16.5' }),
            React.createElement("rect", { height: '4.25', rx: '.75', width: '4.25', x: '3', y: '3' }),
            React.createElement("rect", { height: '4.25', rx: '.75', width: '4.25', x: '3', y: '13.5' }),
            React.createElement("rect", { height: '4.25', rx: '.75', width: '4.25', x: '3', y: '24' })))
    },
    itemNote: {
        title: 'Item Note',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M18.9 29.125H5.626a1.75 1.75 0 01-1.75-1.75V4.625c0-.966.784-1.75 1.75-1.75h22.75c.966 0 1.75.784 1.75 1.75v13.276c0 .463-.184.908-.512 1.236l-9.476 9.476a1.75 1.75 0 01-1.236.512z' }),
            React.createElement("path", { d: 'M19.625 28.968v-8.593c0-.966.784-1.75 1.75-1.75h8.593' })))
    },
    jobSearchProfile: {
        title: 'Job Search Profile',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'm15.33 31.33-3.53-4.1a2 2 0 0 1 3.07-2.56L18 28.44v-13.1a2 2 0 0 1 4 0v8h4a5.33 5.33 0 0 1 5.33 5.33v2.66M18 10.67v-6a1.33 1.33 0 0 0-1.33-1.34H2A1.33 1.33 0 0 0 .67 4.67v22.66A1.33 1.33 0 0 0 2 28.67h6' }),
            React.createElement("path", { d: 'M20.67 10.67V2A1.33 1.33 0 0 0 19.33.67H4M4.67 20.67H14M9.33 12a2.33 2.33 0 1 0 0-4.67 2.33 2.33 0 0 0 0 4.67ZM14 16.67a4.81 4.81 0 0 0-9.33 0H14Z' })))
    },
    linkedIn: {
        title: 'LinkedIn',
        content: (React.createElement("path", { className: 'Icon--useFill', d: 'M7.615 26.402h-5.67V10.15h5.67v16.252Zm11.772-10.955a2.497 2.497 0 0 0-2.497 2.496v8.459h-5.962V10.15h5.962v1.855a7.887 7.887 0 0 1 4.993-1.867c3.699 0 6.265 2.742 6.265 7.945v8.319h-6.265v-8.459a2.495 2.495 0 0 0-2.496-2.508v.012ZM7.72 4.527A2.917 2.917 0 1 1 4.803 1.61a2.917 2.917 0 0 1 2.894 2.917h.023Z' }))
    },
    mail: {
        title: 'Mail',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M29.417 3.577L2.583 14.534l10.5 4.037z' }),
            React.createElement("path", { d: 'M29.417 3.577L24.75 24.915 13.083 18.57zM13.083 18.571v9.227l4.084-6.92' })))
    },
    mailchimp: {
        title: 'Mailchimp',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { className: 'Icon--useFill', d: 'M24.0649 15.1182c.2478-.028.4853-.0291.7034 0 .1263-.273.148-.7433.0345-1.2555-.169-.7614-.3974-1.2221-.8696-1.1504-.4722.0717-.4896.6233-.3208 1.3847.095.4283.2642.7944.4525 1.0212Zm-4.0537.6026c.3379.1396.5455.2322.6268.1513.0522-.0505.0365-.1468-.0442-.271-.1666-.2564-.5096-.5165-.8735-.6626-.7442-.3018-1.6317-.2014-2.3163.2622-.2261.156-.4404.372-.4097.5034.01.0424.0437.0744.123.0849.1865.02.8377-.2902 1.5878-.3334.5297-.0306.9682.1254 1.306.2652Zm-.6796.3652c-.44.0655-.6828.2022-.8385.3293-.133.1096-.2152.2306-.2145.3157.0004.0405.019.0638.0337.0755a.1097.1097 0 0 0 .0724.026c.0993 0 .3219-.0842.3219-.0842.6124-.2065 1.0164-.1816 1.4167-.1385.2212.0234.3257.0364.3742-.0351.0144-.0205.0318-.065-.0125-.1326-.1032-.1576-.5474-.424-1.1534-.356Zm3.3644 1.3413c.2988.1384.6279.084.7349-.1212.107-.2053-.0484-.484-.3471-.6222-.299-.1383-.6278-.084-.735.1213-.107.2053.0485.4838.3472.622Zm1.9209-1.5814c-.2427-.0038-.4441.2473-.4497.5608-.0057.3136.1866.571.4292.5749.2428.0039.444-.2472.4497-.5608.0057-.3137-.1865-.571-.4292-.575Zm-16.303 5.655c-.0604-.0713-.1596-.0496-.2556-.0286-.0671.0148-.1431.0316-.2264.03-.1785-.003-.3297-.0751-.4146-.1978-.1106-.1601-.1042-.3986.0179-.6718a5.982 5.982 0 0 1 .057-.1222c.1946-.4115.5204-1.1003.1546-1.7565-.2753-.494-.7243-.8017-1.2642-.8664-.5183-.0618-1.0519.1194-1.3922.473-.537.5583-.6209 1.3178-.517 1.586.038.0984.0975.1256.1407.131.0914.0118.2265-.051.3111-.2653a1.5035 1.5035 0 0 0 .0243-.0698c.0376-.1135.1079-.3245.2229-.4938.1387-.2042.3546-.3447.6082-.396.2582-.052.5222-.0056.7432.1307.376.232.521.6662.3604 1.0806-.083.2143-.2179.624-.1882.9607.0602.6816.505.9552.9047.9843.3886.0138.6602-.1917.7289-.342.0406-.0888.0064-.143-.0157-.1661Z' }),
            React.createElement("path", { className: 'Icon--useFill', d: 'M12.0083 8.9846c1.2673-1.38 2.8277-2.5798 4.2252-3.2535.0483-.0233.0997.0262.0735.071-.111.1893-.3247.5948-.3924.9024-.0106.048.0448.084.0877.0564.8696-.5585 2.3822-1.1568 3.7088-1.2337.057-.0033.0846.0655.0392.0982-.2016.1458-.4223.3477-.5836.5518-.0273.0348-.0015.0848.0444.085.9317.0063 2.2449.3135 3.1009.7659.058.0306.0167.1363-.0481.1223-1.2951-.2798-3.4152-.492-5.6173.0142-1.966.4518-3.4667 1.1495-4.5614 1.8997-.0553.038-.1218-.031-.077-.0797Zm11.5389 13.9516c.0375-.0148.0634-.0553.059-.0954-.0052-.0493-.052-.0852-.1043-.0802 0 0-2.7047.3773-5.26-.5041.2783-.8523 1.0185-.5445 2.137-.4594 2.0162.1132 3.8232-.1643 5.1586-.5254 1.1572-.3131 2.6772-.93 3.8576-1.808.3982.8242.5388 1.7313.5388 1.7313s.3082-.052.5659.0973c.2433.1412.4218.4346.2999 1.193-.2482 1.4172-.8876 2.5674-1.962 3.6255-.654.6633-1.448 1.24-2.3564 1.6594a10.2969 10.2969 0 0 1-1.539.6124c-4.0503 1.2464-8.1961-.124-9.5327-3.0667a4.5616 4.5616 0 0 1-.268-.6951c-.5695-1.9392-.086-4.2658 1.4255-5.7303 0 0-.0002-.0005-.0001-.0006.093-.0933.1882-.2031.1882-.3414 0-.1155-.078-.2375-.1456-.324-.5286-.7225-2.3603-1.954-1.9926-4.3372.264-1.712 1.853-2.9177 3.3346-2.8463.125.006.2505.0134.3754.0204.642.0357 1.2022.1133 1.7308.1342.8845.036 1.68-.0851 2.6222-.8248.3179-.2496.5726-.466 1.0038-.5348.0452-.0073.158-.0453.3834-.0354.23.0116.4488.071.6457.1945.7552.4736.8624 1.6207.9015 2.4597.0224.479.0838 1.6378.1048 1.9704.048.7607.2602.868.6896 1.001.2414.075.4656.1308.7959.218.9998.2647 1.5926.533 1.9663.8777.2227.2155.3264.4443.3583.6626.118.8103-.6677 1.8115-2.7474 2.721-2.2735.9943-5.0314 1.246-6.937 1.046a554.396 554.396 0 0 1-.6677-.071c-1.5243-.1935-2.3938 1.6627-1.479 2.9344.5896.8195 2.1955 1.353 3.8023 1.3532 3.684.0005 6.5158-1.482 7.569-2.7622.0316-.0383.0347-.0424.0844-.1131.0517-.0736.009-.1142-.0555-.0726-.8606.5549-4.683 2.7576-8.7717 2.0949 0 0-.497-.077-.9504-.2433-.3604-.132-1.1146-.459-1.2063-1.1881 3.2996.9615 5.3772.0525 5.3772.0525ZM5.4237 15.5476c-1.1475.2102-2.1589.823-2.7773 1.6695-.3697-.2904-1.0584-.8528-1.18-1.072-.9874-1.7665 1.0776-5.2011 2.52-7.1408 3.565-4.7937 9.1488-8.422 11.7337-7.7638.42.112 1.8119 1.6325 1.8119 1.6325s-2.5838 1.3508-4.98 3.2336c-3.2285 2.3424-5.6673 5.7469-7.1284 9.441ZM7.352 23.654a2.9242 2.9242 0 0 1-.5295.035c-1.7267-.0436-3.5917-1.5082-3.777-3.2452-.2049-1.9198.8362-3.3974 2.6796-3.7477a3.3217 3.3217 0 0 1 .7738-.052c1.033.0533 2.5548.8006 2.9025 2.9205.308 1.8776-.181 3.7893-2.0494 4.0894Zm23.3893-3.3995c-.015-.0493-.1111-.3812-.2435-.7811-.1325-.4-.2695-.6814-.2695-.6814.531-.7492.5405-1.4191.4699-1.7985-.0755-.4704-.2832-.8712-.702-1.2855-.419-.4143-1.2756-.8386-2.4794-1.1571-.1378-.0364-.5918-.1538-.6318-.1652-.003-.0247-.0331-1.4033-.0606-1.9951-.02-.4277-.059-1.0956-.2788-1.7535-.2621-.8904-.7187-1.6696-1.289-2.168C26.83 6.9324 27.812 5.24 27.8097 3.7878 27.805.9956 24.1654.1506 19.6802 1.9006c-.0048.0018-.9436.377-.9504.3801-.0042-.0039-1.718-1.5883-1.7438-1.6094C11.8722-3.5316-4.1166 13.214.9953 17.2809l1.1172.8917c-.2898.7073-.4037 1.5177-.3107 2.3892.1195 1.1192.7322 2.1923 1.7254 3.0213.9428.787 2.1824 1.2852 3.3853 1.2842 1.9893 4.3194 6.5345 6.9693 11.8638 7.1183 5.7167.16 10.5156-2.3674 12.5263-6.9076.1315-.3188.6896-1.7545.6896-3.022 0-1.2736-.7642-1.8014-1.251-1.8014Z' })))
    },
    magicWand: {
        title: 'Magic Wand',
        content: (React.createElement("path", { d: 'M9.423 8.652l5.119 1.58 3.725-3.083a.571.571 0 01.956.433l-.15 5.458 4.645 2.566a.6.6 0 01-.136 1.08l-5.078 1.817-1.817 5.079a.599.599 0 01-1.08.136l-2.567-4.645-5.458.15a.571.571 0 01-.433-.956l3.084-3.727-1.58-5.118a.63.63 0 01.77-.77zM19 19l11 11M23 3.5h4M25.5 2v4M4 26.5h4M5.5 24v4M12.5 5V2M2 13.5h3' }))
    },
    mapMarker: {
        title: 'Map Marker',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M11 11a5 5 0 1 0 10 0 5 5 0 1 0-10 0Z' }),
            React.createElement("path", { d: 'M16 1a10 10 0 0 1 10 10c0 4.5427-6.7653 15.9333-9.1667 19.5533a1 1 0 0 1-1.6666 0C12.7653 26.9333 6 15.5427 6 11A10 10 0 0 1 16 1Z' })))
    },
    messagesBubble: {
        title: 'Messages Bubble',
        content: (React.createElement("path", { d: 'M16 1.3C7.5 1.3.7 7 .7 14a11.7 11.7 0 0 0 4.5 9L2 30.7l8.5-4.9c1.8.6 3.6.9 5.5.9 8.5 0 15.3-5.7 15.3-12.7 0-7-6.8-12.7-15.3-12.7Z' }))
    },
    moveRight: {
        title: 'Move Right',
        content: (React.createElement("path", { d: 'M16.7 16.7h14.6M26 11.3l5.3 5.4L26 22M8.7.7H2C1.3.7.7 1.3.7 2v28c0 .7.6 1.3 1.3 1.3h6.7c.7 0 1.3-.6 1.3-1.3V2C10 1.3 9.4.7 8.7.7Z' }))
    },
    multipleNeutral: {
        title: 'Multiple Neutral',
        content: (React.createElement("path", { d: 'M10 16a5.7 5.7 0 1 0 0-11.3A5.7 5.7 0 0 0 10 16ZM.7 27.3a9.3 9.3 0 0 1 18.6 0H.7Zm17-20.6a5.7 5.7 0 1 1 .3 7.6m1.3 4.1a9.3 9.3 0 0 1 12 9h-8.6' }))
    },
    navigationMenu: {
        title: 'Navigation Menu',
        content: React.createElement("path", { d: 'M3 24.004h26M3 16.004h26M3 8.004h26' })
    },
    newNote: {
        title: 'New Note',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '22.563', cy: '22.563', r: '7.5' }),
            React.createElement("path", { d: 'M22.563 18.813v7.5M18.813 22.563h7.5M11.313 26.313h-7.5a1.83 1.83 0 01-1.876-1.875V5.82a1.946 1.946 0 011.875-2.008h18.75a1.946 1.946 0 011.875 2.008v5.492M7.563 1.938v5.625M13.188 1.938v5.625M18.813 1.938v5.625' })))
    },
    note: {
        title: 'Note',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M18.9 29.125H5.626a1.75 1.75 0 01-1.75-1.75V4.625c0-.966.784-1.75 1.75-1.75h22.75c.966 0 1.75.784 1.75 1.75v13.276c0 .463-.184.908-.512 1.236l-9.476 9.476a1.75 1.75 0 01-1.236.512z' }),
            React.createElement("path", { d: 'M19.625 28.968v-8.593c0-.966.784-1.75 1.75-1.75h8.593M10.875 9.875h14M10.875 15.125H17' })))
    },
    notesChecklistFlip: {
        title: 'Notes Checklist Flip',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M23.3 23.3a1.3 1.3 0 0 0-1.3 1.4v6.6H3.3A1.3 1.3 0 0 1 2 30V4.7a1.3 1.3 0 0 1 1.3-1.4h25.4A1.3 1.3 0 0 1 30 4.7v18.6h-6.7Zm6.7 0-8 8M6 .7v6m6.7-6v6m6.6-6v6m6.7-6v6' }),
            React.createElement("path", { d: 'm12.7 10-4 4-2-2m6 5.3-4 4-2-2m8.6-6.6H24m-8.7 6.6H24' })))
    },
    notesTextFlip: {
        title: 'Notes Text Flip',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M23.3 23.3a1.3 1.3 0 0 0-1.3 1.4v6.6H3.3A1.3 1.3 0 0 1 2 30V4.7a1.3 1.3 0 0 1 1.3-1.4h25.4A1.3 1.3 0 0 1 30 4.7v18.6h-6.7Zm6.7 0-8 8M6 .7v6m6.7-6v6m6.6-6v6m6.7-6v6' }),
            React.createElement("path", { d: 'M6.7 16.7 8 15.3a1.9 1.9 0 0 1 2.7 0 1.9 1.9 0 0 0 2.6 0 1.9 1.9 0 0 1 2.7 0 1.9 1.9 0 0 0 2.7 0 1.9 1.9 0 0 1 2.6 0 1.9 1.9 0 0 0 2.7 0l1.3-1.3M6.7 23.3 8 22a1.9 1.9 0 0 1 2.7 0 1.9 1.9 0 0 0 2.6 0' })))
    },
    notification: {
        title: 'Notification',
        content: (React.createElement("path", { d: 'M13.556 27.583a2.55 2.55 0 004.895 0M16 4.667v-2.75M16 4.667a9.167 9.167 0 019.167 9.166c0 8.612 1.833 10.084 1.833 10.084H5s1.833-2.342 1.833-10.084A9.167 9.167 0 0116 4.667z' }))
    },
    options: {
        title: 'Options',
        content: (React.createElement("path", { className: 'Icon--useFill', d: 'M3.86206897,12 C5.99503076,12 7.72413793,13.790861 7.72413793,16 C7.72413793,18.209139 5.99503076,20 3.86206897,20 C1.72910717,20 0,18.209139 0,16 C0,13.790861 1.72910717,12 3.86206897,12 Z M16,12 C18.1329618,12 19.862069,13.790861 19.862069,16 C19.862069,18.209139 18.1329618,20 16,20 C13.8670382,20 12.137931,18.209139 12.137931,16 C12.137931,13.790861 13.8670382,12 16,12 Z M28.137931,12 C30.2708928,12 32,13.790861 32,16 C32,18.209139 30.2708928,20 28.137931,20 C26.0049692,20 24.2758621,18.209139 24.2758621,16 C24.2758621,13.790861 26.0049692,12 28.137931,12 Z' }))
    },
    person: {
        title: 'Person',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '16', cy: '7.771', r: '5.688' }),
            React.createElement("path", { d: 'M16 15.083c-6.282 0-11.375 5.093-11.375 11.375v3.25h22.75v-3.25A11.373 11.373 0 0016 15.083h0z' })))
    },
    print: {
        title: 'Print',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M8.35 21.983H4.783A1.783 1.783 0 013 20.2v-8.917c0-.985.798-1.783 1.783-1.783h23.184c.985 0 1.783.798 1.783 1.783V20.2c0 .985-.798 1.783-1.783 1.783H24.4M6.75 12.792h.5' }),
            React.createElement("path", { d: 'M8.625 17h15.5v12.056h-15.5zM24.125 8.889h-15.5V3.722c0-.95.771-1.722 1.722-1.722h12.056c.95 0 1.722.771 1.722 1.722V8.89zM12.375 20.658h8M12.375 24.369h5.188' })))
    },
    ratingStar: {
        title: 'Rating Star',
        content: (React.createElement("path", { d: 'M15.4 2a.7.7 0 0 1 1.2 0l3.4 9.7h9.5a.7.7 0 0 1 .5 1.1l-8 6.6 3.3 10a.7.7 0 0 1-1 .8l-8.3-6-8.3 6a.7.7 0 0 1-1-.7l3.3-10-8-6.7a.7.7 0 0 1 .5-1.1H12L15.4 2Z' }))
    },
    refresh: {
        title: 'Refresh',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M8.727 18.718v5.523H3' }),
            React.createElement("path", { d: 'M8.367 24.245C4.31 20.154 3.778 13.88 7.094 9.209c3.317-4.671 9.574-6.463 14.997-4.295' }),
            React.createElement("path", { d: 'M8.36 24.238c-4.381-4.416-4.593-11.312-.489-15.97 4.104-4.658 11.195-5.572 16.423-2.116 5.228 3.456 6.901 10.164 3.875 15.534-3.026 5.371-9.772 7.667-15.624 5.319' })))
    },
    relations: {
        title: 'Relations',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M26.875 10.884V3.777c0-.982-.795-1.777-1.777-1.777H3.777C2.795 2 2 2.795 2 3.777V23.32c0 .982.795 1.777 1.777 1.777h8.884M2 7.592h24.875' }),
            React.createElement("circle", { cx: '22.875', cy: '16.781', r: '2.594' }),
            React.createElement("path", { d: 'M22.875 21.684A5.876 5.876 0 0017 27.559v1.678h11.75V27.56a5.875 5.875 0 00-5.875-5.875h0zM5.75 12.792h.5M5.75 16.542h.5M5.75 20.292h.5M11.375 13.119h5.188M11.375 16.847h4.25M11.375 20.567h3.313' })))
    },
    roadSignBanned: {
        title: 'Road Sign Banned',
        content: (React.createElement("path", { d: 'M.7 16a15.3 15.3 0 1 0 30.6 0A15.3 15.3 0 0 0 .7 16ZM5.2 5.2l21.6 21.6' }))
    },
    treeStructure: {
        title: 'Tree Structure',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M5 24.9973C5.10073 22.7808 6.07559 20.6945 7.71116 19.1951C9.34673 17.6957 11.5097 16.9055 13.7267 16.9973H18.2733C20.4903 16.9055 22.6533 17.6957 24.2888 19.1951C25.9244 20.6945 26.8993 22.7808 27 24.9973V24.9973' }),
            React.createElement("path", { d: 'M16 8.99733V24.9973' }),
            React.createElement("path", { d: 'M16 8.99733C18.2091 8.99733 20 7.20647 20 4.99733C20 2.78819 18.2091 0.99733 16 0.99733C13.7909 0.99733 12 2.78819 12 4.99733C12 7.20647 13.7909 8.99733 16 8.99733Z' }),
            React.createElement("path", { d: 'M5 30.9973C6.65685 30.9973 8 29.6542 8 27.9973C8 26.3405 6.65685 24.9973 5 24.9973C3.34315 24.9973 2 26.3405 2 27.9973C2 29.6542 3.34315 30.9973 5 30.9973Z' }),
            React.createElement("path", { d: 'M16 30.9973C17.6569 30.9973 19 29.6542 19 27.9973C19 26.3405 17.6569 24.9973 16 24.9973C14.3431 24.9973 13 26.3405 13 27.9973C13 29.6542 14.3431 30.9973 16 30.9973Z' }),
            React.createElement("path", { d: 'M27 30.9973C28.6569 30.9973 30 29.6542 30 27.9973C30 26.3405 28.6569 24.9973 27 24.9973C25.3431 24.9973 24 26.3405 24 27.9973C24 29.6542 25.3431 30.9973 27 30.9973Z' })))
    },
    schedule: {
        title: 'Schedule',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '16', cy: '16', r: '13.364' }),
            React.createElement("path", { d: 'M16 16v-4.773M16 16l5.965 5.967' })))
    },
    search: {
        title: 'Search',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '12.95', cy: '12.95', r: '10.95' }),
            React.createElement("path", { d: 'M20.694 20.693l8.494 8.495' })))
    },
    share: {
        title: 'Share',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '6.295', cy: '14.114', r: '4.614' }),
            React.createElement("circle", { cx: '24.705', cy: '6.955', r: '4.614' }),
            React.createElement("circle", { cx: '24.705', cy: '23.318', r: '4.614' }),
            React.createElement("path", { d: 'M11.563 12.372l7.874-3.063M11.37 16.902l8.26 4.129' })))
    },
    shoppingCart: {
        title: 'Shopping Cart',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M9.364 25.068H21.99a1.91 1.91 0 001.883-1.59l3.356-19.727a1.91 1.91 0 011.882-1.588h1.253M11.75 27.932a.477.477 0 110 .954.477.477 0 010-.954M21.295 27.932a.477.477 0 110 .954.477.477 0 010-.954' }),
            React.createElement("path", { d: 'M24.577 19.34H9.213a3.818 3.818 0 01-3.703-2.89L3.664 9.066a.955.955 0 01.927-1.186h21.934' })))
    },
    singleNeutralActionsAdd: {
        title: 'Single Neutral Actions Add',
        content: (React.createElement("path", { d: 'M15.3 23.3a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm8-4v8m4-4h-8m-15-17a5.7 5.7 0 1 0 11.4 0 5.7 5.7 0 0 0-11.4 0Zm7 17H.7A9.3 9.3 0 0 1 15 15.5' }))
    },
    singleNeutralActionsChat: {
        title: 'Single Neutral Actions Chat',
        content: (React.createElement("path", { d: 'M30 27.3h-5.7L20 31a.3.3 0 0 1-.6-.3v-3.3h-2.6a1.3 1.3 0 0 1-1.4-1.3v-9.3a1.3 1.3 0 0 1 1.4-1.4H30a1.3 1.3 0 0 1 1.3 1.4V26a1.3 1.3 0 0 1-1.3 1.3Zm-10.7-8h8m-8 4h5.4M4.3 6.3a5.7 5.7 0 1 0 11.4 0 5.7 5.7 0 0 0-11.4 0Zm7 7.7A9.3 9.3 0 0 0 .7 23.4h10.6' }))
    },
    singleNeutralActionsDownload: {
        title: 'Single Neutral Actions Download',
        content: (React.createElement("path", { d: 'M15.3 23.3a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm8-4v8m0 0-3-3m3 3 3-3m-22-18a5.7 5.7 0 1 0 11.4 0 5.7 5.7 0 0 0-11.4 0Zm7 17H.7A9.3 9.3 0 0 1 15 15.5' }))
    },
    singleNeutralActionsMail: {
        title: 'Single Neutral Actions Mail',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M31.3 21.3V30a1.3 1.3 0 0 1-1.3 1.3H16.7a1.3 1.3 0 0 1-1.4-1.3v-8.7' }),
            React.createElement("path", { d: 'M31.3 21.3v-.6a1.3 1.3 0 0 0-1.3-1.4H16.7a1.3 1.3 0 0 0-1.4 1.4v.6l7 4.4a2 2 0 0 0 2 0l7-4.4Zm-27-15a5.7 5.7 0 1 0 11.4 0 5.7 5.7 0 0 0-11.4 0Zm7 17H.7A9.3 9.3 0 0 1 15 15.5' })))
    },
    singleNeutralActionsMobile: {
        title: 'Single Neutral Actions Mobile',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M30 14h-9.3c-.8 0-1.4.6-1.4 1.3V30c0 .7.6 1.3 1.4 1.3H30c.7 0 1.3-.6 1.3-1.3V15.3c0-.7-.6-1.3-1.3-1.3Zm-20-2A5.7 5.7 0 1 0 10 .7 5.7 5.7 0 0 0 10 12Zm5.3 3.7A9.3 9.3 0 0 0 .7 23.3h14.6' }),
            React.createElement("path", { d: 'M25.3 27.7a.3.3 0 1 1 0-.7m0 .7a.3.3 0 1 0 0-.7' })))
    },
    singleNeutralActionsRemove: {
        title: 'Single Neutral Actions Remove',
        content: (React.createElement("path", { d: 'M31.3 23.3a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-5.1-2.8-5.7 5.7m5.7 0-5.7-5.7M10 12A5.7 5.7 0 1 0 10 .7 5.7 5.7 0 0 0 10 12Zm1.3 11.3H.7A9.3 9.3 0 0 1 15 15.5' }))
    },
    singleNeutralActionsShare: {
        title: 'Single Neutral Actions Share',
        content: (React.createElement("path", { d: 'M16.33 6.33a5.67 5.67 0 1 0 11.34 0 5.67 5.67 0 0 0-11.34 0Zm-3.04 13.65a9.33 9.33 0 0 1 18.04 3.35H20.67m-20-2.66v10.66m20-1.33a4 4 0 0 0-4-4h-5a4 4 0 0 0-4-4h-7v8h20Zm-13-4h4' }))
    },
    singleNeutralActionsUpload: {
        title: 'Single Neutral Actions Upload',
        content: (React.createElement("path", { d: 'M15.33 23.33a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm8 4v-8m0 0-3 3m3-3 3 3m-22-16a5.67 5.67 0 1 0 11.34 0 5.67 5.67 0 0 0-11.34 0Zm7 17H.67a9.33 9.33 0 0 1 14.37-7.85' }))
    },
    spreadsheet: {
        title: 'Spreadsheet',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M6.636 9.119h18M6.636 14.5h18M6.636 20.881h9.422M9.455 26V6M17.9 29.125H4.626a1.75 1.75 0 01-1.75-1.75V4.625c0-.966.784-1.75 1.75-1.75h22.75c.966 0 1.75.784 1.75 1.75v13.276c0 .463-.184.908-.512 1.236l-9.476 9.476a1.75 1.75 0 01-1.236.512z' }),
            React.createElement("path", { d: 'M18.625 28.968v-8.593c0-.966.784-1.75 1.75-1.75h8.593' })))
    },
    stopwatch: {
        title: 'Stopwatch',
        content: (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: '15.5', cy: '18.625', r: '10.5' }),
            React.createElement("path", { d: 'M22.5 10.75l2.188-2.187M24.25 8.125l.875.875M15.5 8.125v-5.25M18.125 2.875h-5.25M15.5 19.5l-4.375-4.843' })))
    },
    subtract: {
        title: 'subtract',
        content: React.createElement("path", { d: 'M2.0938 16.0938h28' })
    },
    task: {
        title: 'Task',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M20.357 14.571l-4.095 5.477a.77.77 0 01-1.162.083l-2.457-2.464' }),
            React.createElement("path", { d: 'M14.977 3.73a1.955 1.955 0 013.046 0l1.813 2.257c.418.52 1.072.792 1.735.72l2.878-.313a1.954 1.954 0 012.159 2.16l-.313 2.88c-.072.663.2 1.317.72 1.735l2.256 1.814a1.956 1.956 0 010 3.048l-2.264 1.806a1.959 1.959 0 00-.72 1.737l.314 2.88a1.955 1.955 0 01-2.16 2.16l-2.878-.313a1.952 1.952 0 00-1.734.72l-1.806 2.248a1.953 1.953 0 01-3.046 0l-1.813-2.256a1.956 1.956 0 00-1.735-.72l-2.879.314a1.952 1.952 0 01-2.158-2.16l.313-2.88a1.958 1.958 0 00-.72-1.737L3.73 18.017a1.955 1.955 0 010-3.048l2.255-1.814c.52-.418.792-1.072.72-1.736l-.313-2.88A1.955 1.955 0 018.55 6.38l2.879.314c.663.071 1.317-.2 1.735-.72l1.813-2.243z' })))
    },
    taskListPin: {
        title: 'Task List Pin',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { className: 'Icon--useThinStroke', d: 'M27.33 12.67A1.33 1.33 0 0 0 26 11.33H6a1.33 1.33 0 0 0-1.33 1.34V30A1.33 1.33 0 0 0 6 31.33h12a3.7 3.7 0 0 0 2.28-.94l6.11-6.11c.56-.63.9-1.44.94-2.28v-9.33Z' }),
            React.createElement("path", { className: 'Icon--useThinStroke', d: 'M19.33 31v-6.33a1.33 1.33 0 0 1 1.34-1.34H27M11.33 4.67a4 4 0 1 0 8 0 4 4 0 0 0-8 0Zm4 4v4' }),
            React.createElement("path", { className: 'Icon--useThinStroke', d: 'M15.33 3.33a1.33 1.33 0 0 1 1.34 1.34m-7.34 12H20m-10.67 4H20m-10.67 4H16' })))
    },
    upload: {
        title: 'Upload',
        content: (React.createElement("path", { d: 'M15.336 21V6M20.767 11.625L15.337 6l-5.432 5.625M29.155 21v1.875c0 2.071-1.62 3.75-3.62 3.75H5.62c-2 0-3.621-1.679-3.621-3.75V21' }))
    },
    view: {
        title: 'View',
        content: (React.createElement(React.Fragment, null,
            React.createElement("path", { d: 'M16 7.0013c-5.3747-.0906-10.9333 3.6654-14.428 7.512a2.2173 2.2173 0 000 2.968c3.4187 3.7654 8.9613 7.608 14.428 7.516 5.4667.092 11.0107-3.7506 14.432-7.516a2.2173 2.2173 0 000-2.968C26.9333 10.6667 21.3747 6.9107 16 7.0013z' }),
            React.createElement("path", { d: 'M21 16a5 5 0 11-5-5.0013A4.9987 4.9987 0 0121 16z' })))
    }
};
export default iconTypes;
//# sourceMappingURL=iconTypes.js.map